import { RequireAccess } from '@/components/require-access'
import type { RoleEnumKey } from '@jobilla/nexus-sdk'
import { UserData } from '@jobilla/nexus-sdk'
import { Table, TCell, TRow } from '@jobilla/starfield'
import { useTranslation } from 'react-i18next'
import { SubtleLoader } from '../../../../rapid-ui'
import { OrganisationMemberRow } from './organization-member-row'

export interface OrganizationMembersTableProps {
	users: UserData[] | undefined
	isLoading: boolean
	isPlaceholderData: boolean
	isSuccess: boolean
	isJobillan: boolean
	currentUserId: string | null
	onRoleChange: (newRole: RoleEnumKey, userId: string) => void
	onRemoveClick: (userId: string, name: string, email: string) => void
}

export function OrganizationMembersTable({
	users,
	isLoading,
	isPlaceholderData,
	isSuccess,
	isJobillan,
	currentUserId,
	onRoleChange,
	onRemoveClick,
}: OrganizationMembersTableProps) {
	const { t } = useTranslation('common')

	if (isLoading) {
		return <SubtleLoader delay={0} />
	}

	return (
		<div
			className={`transition-opacity duration-200 ${isPlaceholderData ? 'opacity-50' : 'opacity-100'}`}
		>
			<Table
				head={
					<TRow>
						<TCell>{t('organization.membersTable.name')}</TCell>
						<TCell>{t('organization.membersTable.joinedAt')}</TCell>
						<TCell>{t('organization.membersTable.changeRole')}</TCell>
						<RequireAccess permission="organisation:remove-member">
							<TCell>{t('organization.membersTable.remove')}</TCell>
						</RequireAccess>
					</TRow>
				}
			>
				{isSuccess && Array.isArray(users) && users.map(user => (
					<OrganisationMemberRow
						key={user.userId}
						user={user}
						isJobillan={isJobillan}
						isCurrentUser={user.userId === currentUserId}
						onRoleChange={onRoleChange}
						onRemoveClick={onRemoveClick}
					/>
				))}
			</Table>
		</div>
	)
}
